import React, { useState, useEffect, useRef } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useStyle } from './PrequalStyle.js';
import EirPrequalPhoneNumberForm from './EirPrequalPhoneNumberForm';
import EirPrequalEircode from './EirPrequalEircode';
import EirAfterPrequalForm from './EirAfterPrequalForm';
import EirPrequalUnderMaintenanceForm from './EirPrequalUnderMaintenanceForm.js';
import {
  useLocalStorage,
  usePrequalSessionCookie,
} from './EirPrequalPersistance';
import { PREQUAL_BY_EIRCODE_FAILED } from './Constants';
import PubSub from 'pubsub-js';
import Loading from './Loading';
import { getPrequalFromId } from './EirPrequalIntegration';
import { checkPrequalForm } from './EirPrequalUtil.js';

export default function EirPrequalForm(props) {
  const [fontColor, setFontColor] = useState('');
  const [eircodeFieldVisible, setEircodeFieldVisible] = useState(true);
  const [phoneNumberFieldVisible, setPhoneNumberFieldVisible] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [isPrequalDone, setIsPrequalDone] = useState(false);
  const [isPrequalByEircodeFailed, setIsPrequalByEircodeFailed] =
    useState(false);
  const { getSessionCookie, setSessionCookie } = usePrequalSessionCookie();
  const prequalData = useRef('');
  const classes = useStyle();
  const { getLocalStorage, clearLocalStorage, setLocalStorage } =
    useLocalStorage();
  //default props
  let defaultProps = {
    title: props.resources.resources.title,
    text: props.resources.resources.text,
    backgroundImage: props.resources.resources.backgroundImage.path,
    foregroundImageMobile: props.resources.resources.bannerImageMobile.path,
    foregroundImageDesktop: props.resources.resources.bannerImageDesktop.path,
  };
  //this contains form elements for, if prequal by eircode fails
  let prequalByEircodeFailedProps = {
    title: PREQUAL_BY_EIRCODE_FAILED.title,
    textPrefix: PREQUAL_BY_EIRCODE_FAILED.textPrefix,
    textSuffix: PREQUAL_BY_EIRCODE_FAILED.textSuffix,
    backgroundImage: props.resources.resources.backgroundImage.path,
    foregroundImageMobile: '',
    foregroundImageDesktop: '',
  };

  useEffect(() => {
    if (getSessionCookie('new_prequal_session') === '') {
      clearLocalStorage('eir_prequal_data');
      clearLocalStorage('eir_prequal_result');
      clearLocalStorage('eir_prequal_bundles');
      clearLocalStorage('prequaled_By');
      clearLocalStorage('prequaled_from');
      clearLocalStorage('global_customer_type');
      clearLocalStorage('ls_district');
      clearLocalStorage('ls_county');
      clearLocalStorage('ls_prequalby');
      clearLocalStorage('ls-eir_clicked_context');

      setSessionCookie('new_prequal_session', 'true');
    }
  }, []);

  useEffect(() => {
    if (
      getLocalStorage('eir_prequal_data') &&
     getLocalStorage('prequaled_from') === checkPrequalForm()
    ) {
      setIsPrequalDone(true);
      setIsPrequalByEircodeFailed(false);
    } else setIsPrequalDone(false);
  }, []);

  useEffect(() => {
    if (!fontColor) setFontColor(props.resources.resources.textFontColor);
    PubSub.subscribe('PREQUAL_BYEIRCODE_FAILED_NETWORKERROR', () => {
      SetPrequalData(getLocalStorage('EIRCODE'));
      makePhoneNumberVisible();
      controlIfPrequalByEircodeFailed(true);
    });
  }, []);
  useEffect(() => {
    if (props.loading == true) {
      setShowLoading(true);
      setEircodeFieldVisible(false);
      setPhoneNumberFieldVisible(false);
    } else {
      setShowLoading(false);
    }
  }, [props.loading]);

  //Onload, if ACQ_PREQUAL_RESULT is present in local storage navigate to /broadband/ else /shop/broadband/
  useEffect(() => {
    // get online prequal id from localstorage ACQ_PREQUAL_RESULT
    const prequalResult = getLocalStorage('ACQ_PREQUAL_RESULT');
    if (prequalResult) {
      // get prequal result from DB 
      const fetchPrequalResult = () => {
        
        const res = getPrequalFromId(prequalResult.onlinePrequalId).then(res => {
          res.prequalId = res.id;
          setLocalStorage('eir_prequal_data', JSON.stringify(res));
          setLocalStorage('eir_prequal_result', JSON.stringify(res));
          setLocalStorage('ls_district', prequalResult.addressResponse.town);
          setLocalStorage('ls_county', prequalResult.addressResponse.county);
           prequalResult.phoneNumber !== null
            ? setLocalStorage('prequaled_By', 'Phone')
            : setLocalStorage('prequaled_By', 'Eircode');
          setLocalStorage('prequaled_from', '/broadband/');
          setIsPrequalDone(true);
          setIsPrequalByEircodeFailed(false);
        }).catch(error => {
          console.error('STORE API failed to get prequal results', error);
          setIsPrequalDone(false);
          setIsPrequalByEircodeFailed(false);
        });

      };
      fetchPrequalResult();
      
    } else {
      window.history.pushState(
        {},
        '',
        window.location.origin + '/shop/broadband'
      );
    }
  },[]);

  //enabling the eircode form
  const makeEircodeVisible = () => {
    setEircodeFieldVisible(true);
    setPhoneNumberFieldVisible(false);
    setIsPrequalDone(false);
    controlIfPrequalByEircodeFailed(false);
    PubSub.publish('PREQUAL_FAILURE');
  };

  //enabling the phone number form
  const makePhoneNumberVisible = () => {
    setPhoneNumberFieldVisible(true);
    setEircodeFieldVisible(false);
    setIsPrequalDone(false);
    controlIfPrequalByEircodeFailed(false);
    PubSub.publish('PREQUAL_FAILURE');
  };

  //method for, if the prequal by eircode fails, the phone number form(we are sorry page) will be shown with different title and subtitle.
  const controlIfPrequalByEircodeFailed = (isFailed) => {
    setIsPrequalByEircodeFailed(isFailed);
  };

  //eircode or phone number will be saved(to be shown on we are sorry page) if prequal fails
  const SetPrequalData = (data) => {
    prequalData.current = data;
  };

  return (
    <div className={classes.PrequalFormContainer}>
      {isPrequalDone ? (
        <EirAfterPrequalForm
          prop={props}
          makePhoneNumberVisible={makePhoneNumberVisible}
          makeEircodeVisible={makeEircodeVisible}
          controlIfPrequalByEircodeFailed={controlIfPrequalByEircodeFailed}
          setPrequalData={SetPrequalData}
        />
      ) : (
        <div
          className={classes.PrequalBackGround}
          style={{
            background: `url(${
              isPrequalByEircodeFailed
                ? prequalByEircodeFailedProps.backgroundImage
                : defaultProps.backgroundImage
            }) center top/100% 100% no-repeat`,
          }}
        >
          <div className={classes.PrequalContainer}>
            <Grid className={classes.PrequalLeftPart}>
              <Typography
                className={classes.PrequalHeadingText}
                style={{ color: fontColor }}
                variant={props.resources.useH1 ? 'h1' : 'body1'}
              >
                {isPrequalByEircodeFailed
                  ? prequalByEircodeFailedProps.title
                  : defaultProps.title}
              </Typography>

              <Typography
                className={classes.PrequalSubHeadingText}
                style={{ color: fontColor }}
              >
                {isPrequalByEircodeFailed ? (
                  <React.Fragment>
                    {prequalByEircodeFailedProps.textPrefix}
                    <strong>{prequalData.current}</strong>,
                    {prequalByEircodeFailedProps.textSuffix}
                  </React.Fragment>
                ) : (
                  defaultProps.text
                )}
              </Typography>

              {showLoading && <Loading />}

              {props.resources.underMaintenance && (
                <EirPrequalUnderMaintenanceForm
                  underMaintenanceText={props.resources.underMaintenanceText}
                  underMaintenanceCTAText={
                    props.resources.underMaintenanceCTAText
                  }
                  underMaintenanceRedirectURL={
                    props.resources.underMaintenanceRedirectURL
                  }
                />
              )}
              {!props.resources.underMaintenance && eircodeFieldVisible && (
                <EirPrequalEircode
                  prop={props}
                  makePhoneNumberVisible={makePhoneNumberVisible}
                />
              )}
              {!props.resources.underMaintenance && phoneNumberFieldVisible && (
                <EirPrequalPhoneNumberForm
                  prop={props}
                  makeEircodeVisible={makeEircodeVisible}
                />
              )}
            </Grid>

            <Grid className={classes.PrequalRightPart}>
              {isPrequalByEircodeFailed ? (
                <picture>
                  <source
                    media="(max-width: 1019px)"
                    srcSet={prequalByEircodeFailedProps.foregroundImageMobile}
                  />
                  <img
                    className={classes.PrequalBanner}
                    src={prequalByEircodeFailedProps.foregroundImageDesktop}
                    onError={(event) => {
                      event.target.style.display = 'none';
                    }}
                  />
                </picture>
              ) : (
                <picture>
                  <source
                    media="(max-width: 1019px)"
                    srcSet={defaultProps.foregroundImageMobile}
                  />
                  <img
                    className={classes.PrequalBanner}
                    src={defaultProps.foregroundImageDesktop}
                    onLoad={(event) => {
                      event.target.style.display = 'inline-block';
                    }}
                  />
                </picture>
              )}
            </Grid>
          </div>
        </div>
      )}
      <picture>
        <source
          media="(max-width: 1019px)"
         srcSet={props.resources.resources.prequalBannerCurveMobile.path}
        />
        <img
          className={classes.PrequalBannerCurve}
         src={props.resources.resources.prequalBannerCurveDesktop.path}
        />
      </picture>
    </div>
  );
}
